// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"f3fe8574","309":"13528aa0","881":"3dde097f"}[chunkId] + ".chunk.js";
};